import React, { useState, useEffect } from "react";

function WarehouseTable({ setSelectedJobId }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null); // State to keep track of the selected row
  const { REACT_APP_API_ENDPOINT } = process.env;

  const itemsPerPage = 5;
  const maxPageNumbers = 5;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    fetch(
      `${REACT_APP_API_ENDPOINT}/v1/production/adjustment/getadjustmentproduct`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (!Array.isArray(data)) {
          throw new Error("Fetched data is not an array");
        }

        // Remove duplicates based on adjustment_job_id
        const uniqueData = data.reduce((acc, current) => {
          const x = acc.find(
            (item) => item.adjustment_job_id === current.adjustment_job_id
          );
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []);

        setTableData(uniqueData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPageNumbers = () => {
    const totalPages = Math.ceil(tableData.length / itemsPerPage);
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbers / 2));
    const endPage = Math.min(totalPages, startPage + maxPageNumbers - 1);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`px-3 py-1 rounded-md ${
            i === currentPage ? "bg-gray-300" : "bg-gray-200"
          }`}
        >
          {i}
        </button>
      );
    }

    return pageNumbers;
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    const totalPages = Math.ceil(tableData.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Slice data based on pagination
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const slicedRows = tableData.slice(startIndex, endIndex);

  const handleRowClick = (row) => {
    setSelectedJobId(row.adjustment_job_id);
    setSelectedRow(row);
  };

  return (
    <div className="box-border h-screen w-full p-4 bg-[#FFFFFF] ml-9 mt-5">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-[#99BC85]">
            <tr>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider"
              >
                Job ID
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider"
              >
                Job Name
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider"
              >
                Job Quantity
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider"
              >
                Unit Symbol
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider"
              >
                Job Create At
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {slicedRows.map((row, index) => (
              <tr
                key={index}
                onClick={() => handleRowClick(row)}
                className={selectedRow === row ? "bg-gray-200" : ""}
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  {row.adjustment_job_id}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">{row.job_name}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {row.job_quantity}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {row.unit_symbol}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {row.job_create_at}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Pagination */}
      <div className="flex justify-center mt-4">
        <button
          onClick={handlePrevious}
          className="px-3 py-1 rounded-md mr-2 bg-gray-200 cursor-pointer"
          disabled={currentPage === 1}
        >
          {"<"}
        </button>
        {renderPageNumbers()}
        <button
          onClick={handleNext}
          className="px-3 py-1 rounded-md mr-2 ml-2 bg-gray-200 cursor-pointer"
          disabled={currentPage === Math.ceil(tableData.length / itemsPerPage)}
        >
          {">"}
        </button>
      </div>
      {/* End Pagination */}
    </div>
  );
}

export default WarehouseTable;
